import React, { useEffect, useState, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useMemo } from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { TextField, Divider, CardHeader, Checkbox, FormControlLabel, Select, MenuItem, Switch } from '@material-ui/core';
import SelectedPatientProfileDetails from './selectedPatientProfileDetails';
import SelectedPatientNotifications from './selectedPatientNotifications';
import { useSelector, useDispatch } from "react-redux";
import Skeleton from '@material-ui/lab/Skeleton';
import Box from '@material-ui/core/Box';
import AdviceLibrary, { getAdviceIcon } from '../exerciseLibraryFolder/adviceLibrary';
import SelectedPatientDiagnosis from './SelectedPatientDiagnosis';
import SelectedPatientJourney from './SelectedPatientJourney';
import SelectedPatientPaymentSubscription from './selectedPatientPaymentSubscription';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';


const useStyles = makeStyles((theme) => ({
  removeButton: {
    transition: 'background 0.2s',
    backgroundColor: '#F0F8FF',
    color: '#FF7F27',
      fontWeight: 'bold',
      maxHeight: 30,
      zIndex: 2,
    '&:hover': {
      backgroundColor: '#e6eaf0', // light grey that fits the theme
      color: '#FF7F27',
      fontWeight: 'bold',
      maxHeight: 30,
      zIndex: 2
    },
  },
  orangeFocused: {
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#FF7F27',
    },
    '& .MuiInputBase-input': {
      fontSize: 'clamp(0.72rem, calc(2px + 0.722vw), 1.0rem)',
    },
    '& .MuiInputLabel-root': {
      fontSize: 'clamp(0.65rem, calc(1px + 0.72vw), 0.9rem)',
    },
  },
  alwaysOrangeUnderline: {
    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      borderBottom: '2px solid #FF7F27 !important',
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27 !important',
    },
    '& .MuiInputBase-root': {
      color: '#002D55',
    },
  },
  alwaysShowSpinButtons: {
    '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
      opacity: 1,
      pointerEvents: 'all',
      WebkitAppearance: 'auto',
    },
    // For Firefox
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
  },
  cardGrid: {
    marginTop: "5%",
  },
  cardFiltered: {
    height: '97%',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
  },
  cardOriginal: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    borderRadius: 12
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  exerciseTypographyCardStyling: {
    flexGrow: 1,
    color: "#002D55",
    textAlign: "left",
    marginBottom: 10,
    fontSize: 'clamp(0.68rem, calc(2px + 0.722vw), 1.0rem)',
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  cardClickable: {
    cursor: 'pointer',
    transition: 'border-color 0.2s',
    border: '1px solid transparent',
    '&:hover': {
      borderColor: '#FF7F27',
    },
  },
  confirmButton: {
    backgroundColor: '#002D55',
    color: '#FFFFFF',
    borderRadius: 50,
    border: 'none',
    boxShadow: 'none',
    padding: 'clamp(3px, 0.32vw, 6px) clamp(8px, 0.85vw, 16px)',
    fontSize: 'clamp(0.69rem, 0.75vw, 0.875rem)',
    fontWeight: 600,
    textTransform: 'none',
    minWidth: 'clamp(70px, 5.2vw, 100px)',
    '&:hover': {
      backgroundColor: '#FF7F27',
      boxShadow: 'none',
    },
  },
  cancelButton: {
    backgroundColor: '#ffffff',
    color: '#002D55',
    fontWeight: 'bold',
    borderRadius: 50,
    border: '1px solid #dddddd',
    boxShadow: 'none',
    padding: '8px 18px',
    fontSize: 'clamp(0.69rem, 0.75vw, 0.875rem)',
    textTransform: 'none',
    minWidth: 104,
    '&:hover': {
      backgroundColor: '#ffffff',
      color: '#FF7F27',
      border: '1px solid #dddddd',
      boxShadow: 'none',
    },
  },
  adviceDialogTitle: {
    borderBottom: '1px solid #eeeeee',
    padding: '16px 24px',
  },
  adviceDialogTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  adviceDialogTitleText: {
    flex: 1,
    fontWeight: 600,
    color: '#002D55',
    fontSize: 'clamp(0.95rem, calc(4px + 0.72vw), 1.15rem)',
  },
  adviceDialogCloseButton: {
    color: '#002D55',
    backgroundColor: '#f5f5f5',
    '&:hover': {
      backgroundColor: '#e6eaf0',
      color: '#FF7F27',
    },
  },
  adviceDialogContent: {
    padding: '24px !important',
    overflow: 'auto',
    backgroundColor: '#ffffff',
  },
  adviceDialogSectionLabel: {
    fontSize: 12,
    color: '#666666',
    marginBottom: 8,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  adviceDialogPanel: {
    backgroundColor: '#f5f5f5',
    borderRadius: 18,
    padding: 16,
    marginBottom: 24,
  },
  adviceDialogTitlePanel: {
    color: '#002D55',
    fontWeight: 600,
    fontSize: 'clamp(0.82rem, 0.9vw, 1rem)',
    wordBreak: 'break-word',
  },
  adviceDialogField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 14,
      backgroundColor: '#ffffff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: 14,
      borderColor: '#dddddd',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#FF7F27',
    },
  },
  adviceDialogActions: {
    padding: 16,
    display: 'flex',
    gap: 8,
    justifyContent: 'flex-end',
    borderTop: '1px solid #eeeeee',
    backgroundColor: '#ffffff',
  },
}));


export default function SelectedPatientAdvices(props) {
  const { handleRemoveAdviceFrontend, handleSaveAllAdvices, profiles, diagnosis, phases, selectedPatient, advices, phaseName,
    fetchAdvicesForPatient, fetchAdvicesForPhase,
    selectedPhaseId, setSelectedPhaseId, currentPhaseId, onAddAdvice, onUpdateAdviceImportance, onEditAdvice } = props;
  // NOTE: Avoid render-time logging here to prevent UI stalls on large payloads.
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [openAdvice, setOpenAdvice] = useState(null);
  const userToken = useSelector(state => (state && state.user && state.user.token) || null);
  const [editContent, setEditContent] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const skeletonArray = Array.from({ length: 5 });
  let didCancel = false;
  const handleShowFullAdvice = (advice) => setOpenAdvice(advice);
  const handleCloseFullAdvice = () => setOpenAdvice(null);

  useEffect(() => {
    if (!openAdvice) {
      setEditContent('');
      setIsEditing(false);
      return;
    }
    setEditContent(openAdvice.advice || '');
    setIsEditing(false);
  }, [openAdvice]);

// (debug logging removed)


  // Optionally, a formatter for advice text
  const simpleFormatter = (text, len) => {
    if (!text) return '';
    var i = 0;
    for(i = 0; i < text.length; i = i+len){
      if (i !== 0) {
        const subString = text.slice(0, i).split("").reverse().join("");
        const splitIndex = subString.length - subString.indexOf(' ');
        text = text.slice(0, splitIndex) + "\n" + text.slice(splitIndex);
      }
    }
    return text;
  }


  // Sort advices by importance (ascending, 1 is highest)
  const sortedAdvices = React.useMemo(() => {
    return [...advices].sort((a, b) => (a.importance ?? 9999) - (b.importance ?? 9999));
  }, [advices]);

  // When importance is changed, update all advices to have unique, sequential importance values
  const handleImportanceChange = (advice, newImportance) => {
    // Clamp newImportance to 1..N
    const N = advices.length;
    let imp = Math.max(1, Math.min(newImportance, N));
    // Remove the advice from its old position
    let others = advices.filter(a => a !== advice);
    // Insert advice at the new position
    others.splice(imp - 1, 0, { ...advice, importance: imp });
    // Reassign importance to be 1..N
    const reRanked = others.map((a, idx) => ({ ...a, importance: idx + 1 }));
    if (onUpdateAdviceImportance) {
      // Call parent with all new importance values
      reRanked.forEach((a, idx) => onUpdateAdviceImportance(a, idx + 1));
    }
  };

  const renderAdviceCardIcon = (title, options = {}) => {
    const iconData = getAdviceIcon(title);
    const tileStyle = {
      width: 'clamp(58px, 5vw, 76px)',
      minHeight: options.minHeight || 'clamp(68px, 7vw, 96px)',
      borderRadius: 8,
      backgroundColor: '#eef5fb',
      border: '1px solid #dce7f2',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'clamp(6px, 0.52vw, 8px)',
      boxSizing: 'border-box',
      flexShrink: 0,
      ...options.style,
    };

    if (iconData?.type === 'image' && iconData?.value) {
      return (
        <Box style={tileStyle}>
          <img
            alt={title || 'Advice icon'}
            src={iconData.value}
            style={{ width: '100%', height: '100%', maxWidth: 40, maxHeight: 40, objectFit: 'contain', display: 'block' }}
          />
        </Box>
      );
    }
    const IconComponent = iconData?.value;
    return (
      <Box style={tileStyle}>
        {IconComponent ? <IconComponent style={{ fontSize: 26, color: '#002D55' }} /> : null}
      </Box>
    );
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <main>
        <Container className={classes.cardGrid} maxWidth={false} style={{padding: 0, marginTop: 0}}>
          <Grid container spacing={0} direction="row" style={{width: '100%', margin: 0}}>
            <Grid item sm={12} lg={12} style={{paddingLeft: 0, paddingRight: 0, paddingTop: 0}}>
                <Grid container >
                  <Grid item xs={12} >
                    {/*<Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5} mt={0} >
                        <Button
                          variant="contained"
                          style={{ backgroundColor: '#002D55', color: 'white', marginTop: 4 }}
                          size="large"
                          onClick={handleSaveAllAdvices}
                        >
                          SAVE ALL
                        </Button>
                    </Box>*/}  
                        <Grid container xs={12} direction="row" style={{padding: 4}}>
                          {selectedPatient == undefined || isLoading
                            ? skeletonArray.map((_, idx) => (
                                <Grid item key={idx} xs={12}>
                                  <Paper elevation={2} style={{ marginBottom: 8 }}>
                                    <Card className={classes.cardOriginal} style={{ backgroundColor: "#f5f5f5" }}>
                                      <CardContent >
                                        <Skeleton variant="rect" width="60%" height={30} style={{ marginBottom: 10 }} />
                                        <Skeleton variant="rect" width="80%" height={80} style={{ marginBottom: 10 }} />
                                      </CardContent>
                                    </Card>
                                  </Paper>
                                </Grid>
                              ))
                          : sortedAdvices.map((advice, idx) => (
                                <Grid item key={advice.id ? advice.id : advice.uniqueKey} xs={12} >
                                  <Paper elevation={2} style={{ marginBottom: 'clamp(5px, 0.43vw, 8px)', padding: 'clamp(5px, 0.43vw, 8px)', borderRadius: 14, background: '#eaf2fb', border: '1px solid #d0e4f7' }}>
                                    <Card className={`${classes.cardOriginal} ${classes.cardClickable}`} style={{ display: 'flex', flexDirection: 'column', padding: 0 }}>
                                      <CardContent style={{ padding: 'clamp(6px, 0.69vw, 12px) clamp(6px, 0.69vw, 12px) clamp(5px, 0.43vw, 8px) clamp(6px, 0.69vw, 12px)' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative', padding: 0 }}>
                                          {/* Index TextField first (left) */}
                                          <TextField
                                            type="number"
                                            InputLabelProps={{ shrink: true, style: { color: '#002D55' } }}
                                            value={advice.importance}
                                            onChange={e => handleImportanceChange(advice, parseInt(e.target.value, 10))}
                                            size="small"
                                            style={{ width: 'clamp(22px, 1.85vw, 35px)', backgroundColor: 'transparent', borderRadius: 0, borderBottom: '2px solid #FF7F27', marginRight: '2%', marginLeft: 0 }}
                                            InputProps={{ style: { color: '#002D55', fontSize: 'clamp(0.69rem, 1.04vw, 0.93rem)' } }}
                                            classes={{ root: `${classes.orangeFocused} ${classes.alwaysOrangeUnderline} ${classes.alwaysShowSpinButtons}` }}
                                          />
                                          {/* Title next */}
                                          <Typography gutterBottom className={classes.exerciseTypographyCardStyling} style={{ paddingBottom: 3, margin: 0, whiteSpace: 'pre-line', fontSize: 'clamp(0.68rem, calc(2px + 0.722vw), 1.0rem)', fontWeight: 600, wordBreak: 'break-word' }}>
                                            <pre style={{ fontFamily: 'inherit', fontWeight: 'bold', margin: 0 }}>{simpleFormatter(advice.title, 100)}</pre>
                                          </Typography>
                                          {/* Edit and Remove buttons absolutely positioned in upper right */}
                                          <div style={{ position: 'absolute', right: '0%', top: 0, display: 'flex', gap: 4 }}>
                                            <Button
                                              size="small"
                                              className={classes.removeButton}
                                              style={{ minWidth: 0, width: 'clamp(22px, 1.65vw, 32px)', height: 'clamp(22px, 1.65vw, 32px)', padding: 0, borderRadius: 14, fontSize: 'clamp(0.69rem, 0.85vw, 0.93rem)' }}
                                              onClick={() => onEditAdvice && onEditAdvice(advice)}
                                              title="Edit advice"
                                            >
                                              ✎
                                            </Button>
                                            <Button
                                              size="small"
                                              className={classes.removeButton}
                                              style={{ minWidth: 0, width: 'clamp(22px, 1.65vw, 32px)', height: 'clamp(22px, 1.65vw, 32px)', padding: 0, borderRadius: 14, fontSize: 'clamp(0.69rem, 0.85vw, 0.93rem)' }}
                                              onClick={() => handleRemoveAdviceFrontend(advice)}
                                              title="Remove advice"
                                            >
                                              ✕
                                            </Button>
                                          </div>
                                        </div>
                                        {/* Advice text below, with "view" button if too long */}
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            width: '100%',
                                            marginTop: 'clamp(5px, 0.52vw, 10px)',
                                            marginBottom: 0,
                                            minHeight: 65,
                                          }}
                                        >
                                          <>
                                            <Box style={{ marginRight: 'clamp(8px, 0.78vw, 12px)', alignSelf: 'stretch', display: 'flex' }}>
                                              {renderAdviceCardIcon(advice.title, { minHeight: 65 })}
                                            </Box>
                                            <Typography
                                              style={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 3,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                flex: 1,
                                                marginRight: 35,
                                                maxWidth: '94%',
                                                fontSize: 'clamp(0.62rem, 0.75vw, 0.88rem)',
                                              }}
                                            >
                                              {advice.advice}
                                            </Typography>
                                            {/*<Button
                                              size="small"
                                              style={{ color: "#002D55", fontWeight: 600, minWidth: 32, padding: 0, marginLeft: 0, alignSelf: 'flex-end' }}
                                              onClick={() => { setOpenAdvice(advice); setEditContent(advice.advice || ''); setIsEditing(false); }}
                                            >
                                              VIEW
                                            </Button>*/}
                                          </>
                                        </div>
                                        
                                      </CardContent>
                                    </Card>
                                  </Paper>
                                </Grid>
                              ))}
                        </Grid>
                        <Dialog
                          open={!!openAdvice}
                          onClose={handleCloseFullAdvice}
                          fullWidth
                          PaperProps={{ style: { borderRadius: 18, maxWidth: 800 } }}
                          BackdropProps={{ style: { backgroundColor: 'rgba(100, 100, 100, 0.5)' } }}
                        >
                          <DialogTitle className={classes.adviceDialogTitle}>
                            <Box className={classes.adviceDialogTitleRow}>
                              <Typography className={classes.adviceDialogTitleText}>Edit Advice</Typography>
                              <IconButton className={classes.adviceDialogCloseButton} size="small" onClick={handleCloseFullAdvice}>
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </DialogTitle>
                          <DialogContent className={classes.adviceDialogContent}>
                            <Typography className={classes.adviceDialogSectionLabel}>Title</Typography>
                            <Box className={classes.adviceDialogPanel}>
                              <Typography className={classes.adviceDialogTitlePanel}>{openAdvice?.title || 'Advice'}</Typography>
                            </Box>
                            <Typography className={classes.adviceDialogSectionLabel}>Content</Typography>
                            <Box className={classes.adviceDialogPanel} style={{ marginBottom: 0 }}>
                              <TextField
                                fullWidth
                                multiline
                                minRows={4}
                                variant="outlined"
                                value={editContent}
                                onChange={e => setEditContent(e.target.value)}
                                InputProps={{ style: { whiteSpace: 'pre-wrap', color: '#002D55', fontSize: 'clamp(0.72rem, calc(2px + 0.722vw), 1.0rem)' }, readOnly: !isEditing }}
                                disabled={!isEditing}
                                classes={{ root: classes.adviceDialogField }}
                              />
                            </Box>
                          </DialogContent>
                          <DialogActions className={classes.adviceDialogActions}>
                            {isEditing && (
                              <Button variant="outlined" className={classes.cancelButton} onClick={() => {
                                if (openAdvice) {
                                  setEditContent(openAdvice.advice || '');
                                } else {
                                  setEditContent('');
                                }
                                setIsEditing(false);
                              }}>
                                Cancel
                              </Button>
                            )}
                            {!isEditing && (
                              <Button variant="outlined" className={classes.cancelButton} onClick={handleCloseFullAdvice}>
                                Close
                              </Button>
                            )}
                            {!isEditing && (
                              <Button variant="contained" className={classes.confirmButton} onClick={() => { setIsEditing(true); }}>
                                Edit
                              </Button>
                            )}
                            {isEditing && (
                              <Button variant="contained" className={classes.confirmButton} onClick={async () => {
                                try {
                                  if (!openAdvice) return;
                                  const url = `https://api.virtus-one.com/treatment/advices/${openAdvice.id}/versions/`;
                                  const resp = await fetch(url, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json', 'Authorization': `Token ${userToken}` },
                                    body: JSON.stringify({ content: editContent, patient_user_id: selectedPatient && selectedPatient.user_id ? selectedPatient.user_id : null })
                                  });
                                  if (resp.ok) {
                                    setOpenAdvice(null);
                                    setEditContent('');
                                    setIsEditing(false);
                                    if (typeof fetchAdvicesForPatient === 'function' && selectedPatient && selectedPatient.user_id) {
                                      fetchAdvicesForPatient(selectedPatient.user_id);
                                    }
                                  } else {
                                    const txt = await resp.text();
                                    console.error('Failed to save advice version', resp.status, txt);
                                  }
                                } catch (e) {
                                  console.error('Error saving advice version', e);
                                }
                              }}>
                                Save
                              </Button>
                            )}
                          </DialogActions>
                        </Dialog>
                        
                        <Divider style={{ marginTop: 12, marginBottom: 36 }} />
                  </Grid>
                </Grid>
            </Grid>
          </Grid>
        </Container>
      </main>
    </React.Fragment>
  );
} 